import React from 'react';

export default function Html({
  className = 'h-full [&_ol]:list-decimal [&_ol]:pl-6 [&_ul]:list-disc [&_ul]:pl-6 [&_hr]:my-5 [&_h4]:text- [&_h4]:text-sm [&_h4]:font-semibold [&_h4]:uppercase [&_h4]:tracking-widest [&_h4]:text-primary [&_h4]:leading-4 [&_h4]:mb-5 [&_span]:instructions ',
  html,
  ...rest
}) {
  return <div className={className} dangerouslySetInnerHTML={{ __html: html }} {...rest} />;
}
